import Toast from 'vue-toastification';
import { defineNuxtPlugin } from '#imports';

import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.use(Toast, {
        transition: 'Vue-Toastification__bounce',
        newestOnTop: true,
        position: 'top-left',
        hideProgressBar: true,
        pauseOnHover: false,
    });
});
